const gbk = require('./gbk.js');  //gbk解析
import iconv from 'iconv-lite';
/**
*@description: 除法函数，用来得到精确的除法结果
*@explain  说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
*@param {*} 调用 accDiv(arg1,arg2)
*@return :  arg1除以arg2的精确结果
*/
export const accDiv = (arg1, arg2) => {
	var t1 = 0, t2 = 0, r1, r2;
	try {
		t1 = arg1.toString().split(".")[1].length
	} catch (e) {
	}
	try {
		t2 = arg2.toString().split(".")[1].length
	} catch (e) {
	}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	return (r1 / r2) * Math.pow(10, t2 - t1);
}
/**
*@description: 乘法函数，用来得到精确的乘法结果
*@explain  javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
*@param {*}  调用：accMul(arg1,arg2)
*@return :  arg1乘以arg2的精确结果
*/
export const accMul = (arg1, arg2) => {
	var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length
	} catch (e) {
	}
	try {
		m += s2.split(".")[1].length
	} catch (e) {
	}
	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

/**
*@description: 加法函数，用来得到精确的加法结果
*@explain  avascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
*@param {*} 调用：accAdd(arg1,arg2)
*@return :  arg1加上arg2的精确结果
*/
export const accAdd = (arg1, arg2) => {
	var r1, r2, m;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	return (arg1 * m + arg2 * m) / m;
}

/**
*@description: 减法函数，用来得到精确的减法结果
*@explain  javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的加法结果。
*@param {*} 调用：accSub(arg1,arg2)
*@return :  arg1减去arg2的精确结果
*/
export const accSub = (arg1, arg2) => {
	var r1, r2, m, n;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	//动态控制精度长度
	n = (r1 >= r2) ? r1 : r2;
	return ((arg2 * m - arg1 * m) / m).toFixed(n);
}
const instructConf = {
	CCPWD: "CCPWD,5,000020",// 终端密码设置/登录(CCPWD) 对应 $BDPWX
	CCPWD00: "CCPWD,5,000000",// 终端密码设置/登录(CCPWD) 对应 $BDPWX
	CCVRQ: "CCVRQ,",//反馈软硬件版本信息 对应 $BDVRX
	FCXBB: "FCXBB,0,00",//反馈软硬件版本信息 对应 $DBBXX
	CCICR: "CCICR,0,00",// 对应 $BDICP
	CCZDC: "CCZDC,10",//  3.1.4终端自检(CCZDC)对应 $BDZDX
	CCQJI: "CCQJI,", // SOS查询 对应 $BDQDX
	CCPRQ: "CCPRQ,", //接收位置上报参数设置  对应 $BDPRX
	CCRMO: "CCRMO,PWI,2,5", //  对应 $BDPWI
}
/**
*@description: 指令  
*/
export const sendBuffer = (str) => {
	let instruct = instructConf[str] || str;
	let input = `$${instruct}*${chkBBC(instruct)}`;
	let hexString = `${stringToHex(input)}0D0A`;
	let buffer = hexStringToArrayBuffer(hexString);
	return buffer
}
/**
*@description: bbc 校验
*/
export const chkBBC = (byteArray) => {
	let ascii2hex = (str) => {
		var arr = [];
		for (var i = 0, l = str.length; i < l; i++) {
			var hex = Number(str.charCodeAt(i)).toString(16);
			if (hex.length > 2) {
				arr.push(hex.substring(0, 2));
				arr.push(hex.substring(2, 4));
			} else {
				arr.push(hex);
			}
		}
		return arr;
	}
	let fillZero = (num, n) => {
		var len = num.toString().length;
		while (len < n) {
			num = "0" + num;
			len++;
		}
		return num;
	}
	let hexarr = ascii2hex(byteArray);
	var bcc = 0;
	var xor = 0;
	for (var i = 0; i < hexarr.length; i++) {
		var hexint = parseInt(hexarr[i], 16);
		if (i == 0) { xor = hexint; }
		else {
			bcc = xor ^ hexint;
			xor = bcc;
		}
	}
	let num = fillZero(bcc.toString(16), 2);
	return num.toUpperCase();
}
/**
*@description: bbc 校验  中文字符
*/
export const calculateBCC = (hexString) => {
	let hexStringToByteArray = (str) => {
		const byteArray = [];
		for (let i = 0; i < str.length; i += 2) {
			byteArray.push(parseInt(str.substr(i, 2), 16));
		}
		return byteArray;
	}
	let fillZero = (num, n) => {
		var len = num.toString().length;
		while (len < n) {
			num = "0" + num;
			len++;
		}
		return num;
	}
	const byteArray = hexStringToByteArray(hexString);
	let bcc = 0;
	for (let i = 0; i < byteArray.length; i++) {
		bcc ^= byteArray[i]; // 使用异或操作更新校验字符
	}
	let num = fillZero(bcc.toString(16), 2);
	return num.toUpperCase();
}
/**
*@description: PWI 波速功率 处理
*@param {*}  parseInt
*@Date :  2023-09-06 11:15:10
*/
export const setgradePWI = (inputArray) => {
	let arr = inputArray.map(item => parseInt(item))
	let max = 0;
	let drr = sanheArray(arr);
	drr.map(item => {
		item.list.map(k => {
			if (k.b > max) {
				max = k.b;
			}
			if (k.c > max) {
				max = k.c;
			}
		})
	})
	return max;
}
export const sanheArray = (arr) => {
	let endIndex = 0;
	let list = [];
	for (let index = 0; index < arr.length; index++) {
		const element = arr[index];
		if (element > 0 && endIndex <= index) {
			let he = element * 3;
			let brr = arr.slice(index + 1, he + index + 1);
			if (he == brr.length) {
				let crr = [];
				for (let j = 0; j < element; j++) {
					crr.push({
						a: brr[j * 3],
						b: brr[j * 3 + 1],
						c: brr[j * 3 + 2],
					});
				}
				list.push({
					name: element,
					index: index,
					list: crr
				})
			}
			endIndex = he + index + 1;
		}
	}
	return list
}
/**
*@description: ArrayBuffer转16进度字符串
*/
export const ab2hex = (buffer) => {
	let hexArr = Array.prototype.map.call(
		new Uint8Array(buffer),
		function (bit) {
			return ('00' + bit.toString(16)).slice(-2)
		}
	)
	return hexArr.join('');
}
/**
*@description: 将16进制字符串转换为ArrayBuffer
*/
export const hexStringToArrayBuffer = (hexString) => {
	var buffer = new ArrayBuffer(hexString.length / 2);
	var view = new DataView(buffer);

	for (var i = 0; i < hexString.length; i += 2) {
		var byte = parseInt(hexString.substr(i, 2), 16);
		view.setUint8(i / 2, byte);
	}

	return buffer;
}
/**
*@description: 字符串 转换 ArrayBuffer
*/
export const stringToArrayBuffer = (str) => {
	var buffer = new ArrayBuffer(str.length * 2); // 每个字符占用2个字节
	var view = new Uint16Array(buffer);
	for (var i = 0; i < str.length; i++) {
		view[i] = str.charCodeAt(i);
	}
	return buffer;
}
/**
*@description:  ArrayBuffer转换为字符串：
*/
export const arrayBufferToString = (buffer) => {
	var view = new Uint16Array(buffer);
	var str = "";
	for (var i = 0; i < view.length; i++) {
		str += String.fromCharCode(view[i]);
	}
	return str;
}
/**
*@description: 字符串转换为16进制字符串
*/
export const stringToHex = (input) => {
	var hexString = '';
	for (var i = 0; i < input.length; i++) {
		var hexCharCode = input.charCodeAt(i).toString(16);
		hexString += hexCharCode.padStart(2, '0');
	}
	return hexString.toUpperCase();
}
/**
*@description: 16进制字符串转字符串
*/
export const hexToString = (hex) => {
	var str = '';
	for (var i = 0; i < hex.length; i += 2) {
		var charCode = parseInt(hex.substr(i, 2), 16);
		str += String.fromCharCode(charCode);
	}
	return str;
}
/**
*@description: 十六进制数字转换十进制数字 或 十进制数字转换十六进制数字
*/
export const decToHex = (hex, ty = 16) => {
	if (ty == 16) {
		let n = hex.toString(16).toUpperCase();
		return n
	} else {
		let decimalNumber = parseInt(hex, 16); // 转换为十进制
		return decimalNumber
	}
}
/**
*@description: 判断是否是 UTF8 编码
*/
export const isUTF8 = (buffer) => {
	var isUtf8 = true;
	var end = buffer.length;
	for (var i = 0; i < end; i++) {
		var temp = buffer[i];
		if ((temp & 0x80) == 0) { // 0xxxxxxx
			continue;
		} else if ((temp & 0xC0) == 0xC0 && (temp & 0x20) == 0) { // 110xxxxx 10xxxxxx
			if (i + 1 < end && (buffer[i + 1] & 0x80) == 0x80 && (buffer[i + 1] & 0x40) == 0) {
				i = i + 1;
				continue;
			}
		} else if ((temp & 0xE0) == 0xE0 && (temp & 0x10) == 0) { // 1110xxxx 10xxxxxx 10xxxxxx
			if (i + 2 < end && (buffer[i + 1] & 0x80) == 0x80 && (buffer[i + 1] & 0x40) == 0 &&
				(buffer[i + 2] & 0x80) == 0x80 && (buffer[i + 2] & 0x40) == 0) {
				i = i + 2;
				continue;
			}
		} else if ((temp & 0xF0) == 0xF0 && (temp & 0x08) == 0) { // 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
			if (i + 3 < end && (buffer[i + 1] & 0x80) == 0x80 && (buffer[i + 1] & 0x40) == 0 &&
				(buffer[i + 2] & 0x80) == 0x80 && (buffer[i + 2] & 0x40) == 0 &&
				(buffer[i + 3] & 0x80) == 0x80 && (buffer[i + 3] & 0x40) == 0) {
				i = i + 3;
				continue;
			}
		}
		isUtf8 = false;
		break;
	}
	return isUtf8;
}
/**
*@description: UTF8 汉字转换为十六进制
*/
export const utf8HexString = (inputString) => {
	let gbkBytes = unescape(encodeURIComponent(inputString)).split("").map(val => val.charCodeAt());
	const hexString = Array.from(gbkBytes, byte => byte.toString(16).padStart(2, '0')).join('');
	return hexString.toUpperCase();;
}
/**
*@description: UTF8 将十六进制字符串转回GBK编码的汉字
*/
export const utf8StringZh = (hexString) => {
	const hexArray = hexString.match(/.{2}/g).map(byte => parseInt(byte, 16));
	let gbkString = decodeURIComponent(escape(String.fromCharCode(...hexArray)));
	return gbkString
}
export const tuf8StringToArrayBuffer = (str) => {
	var bytes = new Array();
	var len, c;
	len = str.length;
	for (var i = 0; i < len; i++) {
		c = str.charCodeAt(i);
		if (c >= 0x010000 && c <= 0x10ffff) {
			bytes.push(((c >> 18) & 0x07) | 0xf0);
			bytes.push(((c >> 12) & 0x3f) | 0x80);
			bytes.push(((c >> 6) & 0x3f) | 0x80);
			bytes.push((c & 0x3f) | 0x80);
		} else if (c >= 0x000800 && c <= 0x00ffff) {
			bytes.push(((c >> 12) & 0x0f) | 0xe0);
			bytes.push(((c >> 6) & 0x3f) | 0x80);
			bytes.push((c & 0x3f) | 0x80);
		} else if (c >= 0x000080 && c <= 0x0007ff) {
			bytes.push(((c >> 6) & 0x1f) | 0xc0);
			bytes.push((c & 0x3f) | 0x80);
		} else {
			bytes.push(c & 0xff);
		}
	}
	var array = new Int8Array(bytes.length);
	for (var i in bytes) {
		array[i] = bytes[i];
	}
	return array.buffer;
}
/**
*@description: gbk 汉字转换为十六进制
*/
export const gbkHexString = (inputString) => {
	let uint8Array = gbk.encode(inputString);
	const hexString = Array.from(uint8Array, byte => byte.toString(16).padStart(2, '0')).join('');
	return hexString.toUpperCase();
}
/**
*@description: gbk 将十六进制字符串转回GBK编码的汉字
*/
export const gbkStringZh = (hexString) => {
	const hexArray = hexString.match(/.{2}/g).map(byte => parseInt(byte, 16));
	const decode = gbk.decode(hexArray);
	return decode
}
/**
*@description: GB18030 字符串转换为十六进制GB18030
*/
export const GB18030HexString = (inputString) => {
	const gb18030Bytes = iconv.encode(inputString, 'GB18030');
	const hexString = Array.from(gb18030Bytes, byte => byte.toString(16).padStart(2, '0')).join('');
	return hexString.toUpperCase();
}
/**
*@description: GB18030 将十六进制字符串转回GB18030编码的汉字
*/
export const GB18030StringZh = (hexString) => {
	const uint8Array = new Uint8Array(hexString.match(/.{1,2}|$/g).map(byte => parseInt(byte, 16)));
    const decoded = iconv.decode(uint8Array, 'GB18030');
	return decoded
}
// 指令手机 转换
export const setBluePhone = (locNun) => {
	let numString = Number(locNun);
	let n = decToHex(numString, 16);
	return setPustLing(n, 10)
}
// 指令经纬度 转换
export const setBlueLocations = (locNun) => {
	let lgt = accAdd(locNun, 0.000001)
	let num = parseInt(accMul(lgt, 1000000));
	let n = decToHex(num, 16);
	return setPustLing(n, 8)
}
// 指令时间 转换
export const setBlueTime = (tiem) => {
	let timeBluet = accDiv(tiem, 1000);
	let n = decToHex(timeBluet, 16);
	return setPustLing(n, 8)
}
// 指令高度 转换
export const setBlueHeight = (height) => {
	let num = parseInt(height);
	let n = decToHex(num, 16);
	return setPustLing(n, 4)
}
/**
*@description: hex < num 进行字符串前 补0  hex > num 进行字符串后截取
*@param {*} hex 开始长度
*@param {*} num  总长
*@Date :  2023-09-08 10:52:44
*/
export const setPustLing = (hex, num) => {
	let numString = hex.toString()
	let length = numString.length;
	let cha = length - num;
	if (cha > 0) {
		let setRt = numString.slice(0, num);
		return setRt
	} else {
		let set = '';
		let absoluteValue = Math.abs(cha);
		for (let index = 0; index < absoluteValue; index++) {
			set += '0'
		}
		return `${set}${numString}`;
	}
}
/**
*@description: 时间格式化处理
*@param {*} obj  时间
*@param {*} fmt 式化 默认 yyyy-MM-dd
*@Date :  2023-05-30 14:15:47
*/
export const formatDate = (obj, fmt = 'yyyy-MM-dd hh:mm:ss') => {
	let _this = '';
	if (obj instanceof Date) {
		_this = obj
	} else if (typeof obj === 'number' && obj > 0) {
		_this = new Date(obj)
	} else {
		let mss = obj.replace(/-/gi, '/');
		_this = new Date(mss);
	}
	// const mss = isNumber(obj) ? obj : obj.replace(/-/gi, '/');//兼容苹果
	// let _this = new Date(mss);
	if (_this) {
		let o = {
			'M+': _this.getMonth() + 1, // 月份
			'd+': _this.getDate(), // 日
			'h+': _this.getHours(), // 小时
			'm+': _this.getMinutes(), // 分
			's+': _this.getSeconds(), // 秒
			'q+': Math.floor((_this.getMonth() + 3) / 3), // 季度
			'S': _this.getMilliseconds() // 毫秒
		}
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (_this.getFullYear() + '').substr(4 - RegExp.$1.length))
		for (let k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
	}
	return fmt
}
/**
*@description: 经纬度格式化
*@param {*} 调用  经度  formatDegree(log, 'longitude', 2) 
*@param {*} 调用  纬度  formatDegree(lat, 'latitude', 2) 
*/
export function formatDegree(value, format, digit = 0) {
	if (!value) {
		return '-';
	}
	let DEG = '';
	let str = '';
	if (format === 'latitude') {
		value < 0 ? (DEG = 'S') : (DEG = 'N');
	}
	if (format === 'longitude') {
		value < 0 ? (DEG = 'W') : (DEG = 'E');
	}
	value = Math.abs(value);
	let s1 = Math.floor(value); //度
	let s2 = Math.floor((value - s1) * 60); //分
	let s3 = (((value - s1) * 3600) % 60).toFixed(digit); //秒
	str = `${s1}°${s2}'${s3}"`;
	if (DEG !== '') {
		str = str + DEG;
	}
	return str;
}
/**
*@description: 经纬度格式化
*@param {*} 调用  经度  formatDegree(log, 'longitude', 2) 
*@param {*} 调用  纬度  formatDegree(lat, 'latitude', 2) 
*/
export function formatDegree2(value, digit = 0) {
	if (!value) {
		return '-';
	}
	let DEG = '';
	let str = '';
	value = Math.abs(value);
	let s1 = Math.floor(value); //度
	let s2 = Math.floor((value - s1) * 60); //分
	let s3 = (((value - s1) * 3600) % 60).toFixed(digit); //秒
	str = `${s1}°${s2}'${s3}"`;
	if (DEG !== '') {
		str = str + DEG;
	}
	return str;
}
/**
 *@description:数字不满10补0
 */
 export const formatNumber = (n) => {
	n = n.toString();
	return n[1] ? n : `0${n}`;
};
